import type { NumberBlock } from './types'

export function idx(row: number, col: number, size: number): number {
  return row * size + col
}

export function selectedSum(blocks: NumberBlock[], ids: number[]): number {
  const set = new Set(ids)
  return blocks.reduce((s, b) => (set.has(b.id) ? s + b.value : s), 0)
}

function connectedH(blocks: NumberBlock[], row: number, sc: number, ec: number, size: number): boolean {
  for (let c = sc + 1; c < ec; c++) {
    const i = idx(row, c, size)
    if (i >= blocks.length) return false
    if (blocks[i].value !== 0) return false
  }
  return true
}
function connectedV(blocks: NumberBlock[], col: number, sr: number, er: number, size: number): boolean {
  for (let r = sr + 1; r < er; r++) {
    const i = idx(r, col, size)
    if (i >= blocks.length) return false
    if (blocks[i].value !== 0) return false
  }
  return true
}

export function hasLineMove(blocks: NumberBlock[], size: number): boolean {
  // 가로
  for (let row = 0; row < size; row++) {
    for (let sc = 0; sc < size; sc++) {
      const si = idx(row, sc, size)
      if (si >= blocks.length) continue
      let sum = blocks[si].value
      for (let ec = sc + 1; ec < size; ec++) {
        const ei = idx(row, ec, size)
        if (ei >= blocks.length) break
        if (connectedH(blocks, row, sc, ec, size)) {
          sum += blocks[ei].value
          if (sum === 10) return true
          if (sum > 10) break
        } else break
      }
    }
  }
  // 세로
  for (let col = 0; col < size; col++) {
    for (let sr = 0; sr < size; sr++) {
      const si = idx(sr, col, size)
      if (si >= blocks.length) continue
      let sum = blocks[si].value
      for (let er = sr + 1; er < size; er++) {
        const ei = idx(er, col, size)
        if (ei >= blocks.length) break
        if (connectedV(blocks, col, sr, er, size)) {
          sum += blocks[ei].value
          if (sum === 10) return true
          if (sum > 10) break
        } else break
      }
    }
  }
  return false
}

export function hasRectMove(blocks: NumberBlock[], size: number): boolean {
  for (let sr = 0; sr < size; sr++) {
    for (let sc = 0; sc < size; sc++) {
      for (let er = sr; er < size; er++) {
        for (let ec = sc; ec < size; ec++) {
          let sum = 0, any = false
          for (let r = sr; r <= er; r++) {
            for (let c = sc; c <= ec; c++) {
              const i = idx(r, c, size)
              if (i < blocks.length && blocks[i].value !== 0) { sum += blocks[i].value; any = true }
            }
          }
          if (any && sum === 10) return true
        }
      }
    }
  }
  return false
}

export function hasAnyMove(blocks: NumberBlock[], size: number): boolean {
  return hasLineMove(blocks, size) || hasRectMove(blocks, size)
}

/**
 * 힌트: 합이 10이 되는 직사각형 영역의 블록 id 목록을 반환(없으면 null).
 * 여러 개면 블록 수가 가장 적은(가장 명확한) 조합을 고른다.
 */
export function findHint(blocks: NumberBlock[], size: number): number[] | null {
  let best: number[] | null = null
  for (let sr = 0; sr < size; sr++) {
    for (let sc = 0; sc < size; sc++) {
      for (let er = sr; er < size; er++) {
        for (let ec = sc; ec < size; ec++) {
          let sum = 0
          const ids: number[] = []
          for (let r = sr; r <= er; r++) {
            for (let c = sc; c <= ec; c++) {
              const i = idx(r, c, size)
              if (i < blocks.length && blocks[i].value !== 0) { sum += blocks[i].value; ids.push(blocks[i].id) }
            }
          }
          if (sum === 10 && ids.length > 0 && (!best || ids.length < best.length)) best = ids
        }
      }
    }
  }
  return best
}
